import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  const projetsSlider = document.getElementById("projets_slider");

  if (projetsSlider) {
    const slider = new Splide(projetsSlider, {
      type: "loop",
      perPage: 4,
      perMove: 1,
      gap: 40,
      focus: "left",
      pagination: false,
      arrows: false,
      breakpoints: {
        540: {
          perPage: 1,
          perMove: 1,
          gap: 30,
          focus: 0,
          trimSpace: true,
        },
        768: {
          perPage: 2,
          perMove: 1,
          gap: 20,
          focus: 0,
          trimSpace: true,
        },
        992: {
          perPage: 2,
          perMove: 1,
          gap: 20,
          focus: 0,
          trimSpace: true,
        },
        1200: {
          perPage: 2,
          perMove: 1,
          gap: 20,
          focus: 0,
          trimSpace: true,
        },
      },
      autoScroll: {
        speed: 0.5,
      },
    });
    slider.mount({ AutoScroll });
  }
});
